import Vue from 'vue';
import App from './App.vue';    // 路由挂载
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import request from '@/common/request';

import YDUI from 'vue-ydui'; /* 相当于import YDUI from 'vue-ydui/ydui.rem.js' */
import 'vue-ydui/dist/ydui.px.css';
import store from './store';

Vue.use(ElementUI);
Vue.use(YDUI);

Vue.config.productionTip = false;
Vue.prototype.$http = request;
Vue.prototype.$fileServer = "http://222.92.48.29:20080/api/fileServer/";
Date.prototype.Format = function(fmt)   
{ //author: meizz   
  var o = {   
    "M+" : this.getMonth()+1,                 //月份   
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时   
    "m+" : this.getMinutes(),                 //分   
    "s+" : this.getSeconds(),                 //秒   
    "q+" : Math.floor((this.getMonth()+3)/3), //季度   
    "S"  : this.getMilliseconds()             //毫秒   
  };   
  if(/(y+)/.test(fmt))   
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));   
  for(var k in o)   
    if(new RegExp("("+ k +")").test(fmt))   
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
  return fmt;   
}  
// 实例配置在上面，路由拦截在下面
router.beforeEach((to, from, next) => {
  if (to.meta.noRequireAuth) {  // 判断该路由是否需要登录权限
    next();
  } else {
    if (store.getters.getToken) {  // 通过vuex state获取当前的token是否存在
      next();
    } else {
      Vue.prototype.$message({
        type: 'error',
        message: '登录过期，请重新登录!',
        onClose: function () {
          next('/login');
        }
      });
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
